import { render, staticRenderFns } from "./CardMatchesMobile.vue?vue&type=template&id=33490c0a"
import script from "./CardMatchesMobile.vue?vue&type=script&lang=js"
export * from "./CardMatchesMobile.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports